import qs from 'query-string'

export default {
  computed: {
    clientType () {
      return this.$route.query.client_type ? this.$route.query.client_type : null
    },
    next () {
      return this.$route.query.next ? this.$route.query.next : null
    },
    establishmentId () {
      return this.$route.query.establishment_id ? this.$route.query.establishment_id : null
    }
  },
  methods: {
    redirect (token) {
      let uri = this.next
      uri.includes('?')
        ? uri += '&'
        : uri += '?'
      uri += qs.stringify({
        token: token
      })

      window.location.href = uri
    }
  }
}
